<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.name"
        placeholder="姓名"
        style="width: 200px"
        class="filter-item"
        clearable
        size="small"
      />

      <el-select
        v-model="listQuery.gender"
        placeholder="性别"
        clearable
        style="width: 200px"
        class="filter-item"
        size="small"
      >
        <el-option label="男" value="1" />
        <el-option label="女" value="2" />
      </el-select>
      <el-select
        v-model="listQuery.department_id"
        placeholder="部门"
        clearable
        style="width: 200px"
        class="filter-item"
        size="small"
      >
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in departmentList"
          :key="item.id"
        />
      </el-select>
      <el-select
        v-model="listQuery.job_id"
        placeholder="职级"
        clearable
        style="width: 200px"
        class="filter-item"
        size="small"
      >
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in jobList"
          :key="item.id"
        />
      </el-select>
      <el-select
        v-model="listQuery.check_status"
        placeholder="状态"
        clearable
        style="width: 200px"
        class="filter-item"
        size="small"
      >
        <el-option label="审核中" value="pending" />
        <el-option label="审核成功" value="success" />
        <el-option label="审核失败" value="fail" />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        size="small"
        >搜索</el-button
      >
      <!--      <download-excel-->
      <!--        class="filter-item"-->
      <!--        :fields="json_fields"-->
      <!--        :fetch="handleExport"-->
      <!--        type="xls"-->
      <!--        name="数据统计.xls"-->
      <!--        worksheet="数据统计"-->
      <!--      >-->
      <!--        <el-button type="success" :loading="exportLoading">-->
      <!--          导出数据统计-->
      <!--        </el-button>-->
      <!--      </download-excel>-->
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      size="small"
    >
      <el-table-column align="center" label="ID" width="120">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="姓名" width="120">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="性别" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.gender === 1" type="warning"> 男 </el-tag>
          <el-tag v-else type="success">女</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="部门" width="120">
        <template slot-scope="scope">
          {{ scope.row.department?.name || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="工号" width="120">
        <template slot-scope="scope">
          {{ scope.row.employee_no || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="职级" width="120">
        <template slot-scope="scope">
          {{ scope.row.job?.name || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="上级领导" width="120">
        <template slot-scope="scope">
          {{ scope.row.superior_leader }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="企业邮箱" width="120">
        <template slot-scope="scope">
          {{ scope.row.enterprise_email }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="证件号码" width="120">
        <template slot-scope="scope">
          {{ scope.row.id_number }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.check_status === 'pending'" type="warning">
            审核中
          </el-tag>
          <el-tag
            v-else-if="scope.row.check_status === 'success'"
            type="success"
            >审核成功</el-tag
          >
          <el-tag v-else-if="scope.row.check_status === 'fail'" type="danger"
            >审核失败</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column align="center" label="驳回原因" width="120">
        <template slot-scope="scope">
          {{ scope.row.reject_reason ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
        min-width="120px"
        fixed="right"
      >
        <template slot-scope="scope">
          <div style="margin-top: 0px">
            <el-button
              size="mini"
              type="primary"
              @click="handleCheck(scope.row)"
              v-if="scope.row.check_status == 'pending'"
              >审核
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="审核"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="120px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="部门名称" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <!--        <el-form-item label="权限" prop="permissions">-->
        <!--          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>-->
        <!--          <div style="margin: 15px 0;"></div>-->
        <!--          <el-checkbox-group v-model="form.permissions" @change="handleCheckedPermissionsChange">-->
        <!--            <el-checkbox v-for="permission in permissions" :label="permission.id" :key="permission.id">{{permission.display_name}}</el-checkbox>-->
        <!--          </el-checkbox-group>-->
        <!--        </el-form-item>-->
      </el-form>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div> -->
    </el-dialog>
    <el-dialog
      title="驳回"
      :visible.sync="rejectModalVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            placeholder="驳回理由"
            :rows="4"
            v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="reject('rejectForm')"
            >确认</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import downloadExcel from 'vue-json-excel'
export default {
  components: { downloadExcel },
  data() {
    return {
      dialogFormVisible: false,
      dialogPvVisible: false,
      pvData: [],
      form: {
        id: '',
        name: '',
        permissions: [],
      },
      rules: {
        name: [
          { required: true, message: '部门名称不能为空', trigger: 'change' },
        ],
        permissions: [
          {
            type: 'array',
            required: true,
            message: '权限不能为空',
            trigger: 'change',
          },
        ],
      },
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      listLoading: false,
      exportLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: '',
        username: '',
        email: '',
        vip_level_no: '',
        revenue_type: '',
        start_at: '',
        end_at: '',
        is_active: '',
        status: '',
      },
      jobList: [],
      departmentList: [],
      json_fields: {
        分红时间: {
          field: 'last_login_at',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        用户id: {
          field: 'id',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        姓: {
          field: 'last_name',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        名: {
          field: 'first_name',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        VIP等级: {
          field: 'vip_level_name',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        分红类型: {
          field: 'revenue_type',
          //自定义回调函数
          callback: (value) => {
            return (
              '<p style="mso-number-format:\'\\@\';">' +
              this.revenue_type(value) +
              '</p>'
            )
          },
        },
        来源对象: {
          field: 'source_user_id',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        来源动作: {
          field: 'num',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        奖金金额: {
          field: 'money_reward_value',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        RP: {
          field: 'rp_reward_value',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        结算状态: {
          field: 'status',
          //自定义回调函数
          callback: (value) => {
            return (
              '<p style="mso-number-format:\'\\@\';">' +
              this.status(value) +
              '</p>'
            )
          },
        },
        备注: {
          field: 'num',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
      },
    }
  },
  created() {
    this.getJobList()
    this.getDepartmentList()
    this.getList()
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },

  methods: {
    resetForm() {
      this.form = {
        id: '',
        name: '',
        gender: '',
        department_id: '',
        job_id: '',
        employee_no: '',
        superior_leader: '',
        enterprise_email: '',
        id_number: '',
      }

      this.btnLoading = false
    },
    handleCheck(row) {
      this.$router.push('/employeeApplyLogDetail?id=' + row.id)
    },
    getJobList() {
      request({
        url: '/api/memberend/job/list',
        method: 'get',
        params: { limit: 999999999 },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.jobList = res.data.data
        }
      })
    },
    getDepartmentList() {
      request({
        url: '/api/memberend/department/list',
        method: 'get',
        params: { limit: 999999999 },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.departmentList = res.data.data
        }
      })
    },
    handleExport() {
      if (!this.listQuery.start_at || !this.listQuery.end_at) {
        this.$message.warning('请选择开始与结束日期')
        return
      }
      this.exportLoading = true
      var listQuery = JSON.parse(JSON.stringify(this.listQuery))
      return request({
        url: '/api/backend/dataCount/revenueDataCountList',
        method: 'get',
        params: listQuery,
      })
        .then((response) => {
          return response.data.data
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    changedata(val) {
      console.log(val)
      if (val) {
        this.listQuery.start_at = val[0] + ' 00:00:00'
        this.listQuery.end_at = val[1] + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/memberend/employee/applyLogs',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    edit(val) {
      this.$router.push('/member/editmemberinfo')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
